import ProcessedBooking from "./processedBooking";

export default class ProcessedBookingGroup {
  // A unique identifier for the Event
  eventId: string;
  //   Occurrence date to differentiate between two same EventId events by a different occurrence date.
  eventOccurrenceDate?: Date;
  //   Title of the Event.
  eventTitle: string;
  //   List of Processed Bookings.
  processedBookings: ProcessedBooking[];
  //   Price of the Event.
  eventPrice: number;
  //   Total number of Processed Bookings for an Event.
  processedBookingsCount: number;
  //   Total amount of Processed Bookings for an Event.
  totalPrice: number;
  //   To indicate if all Processed Bookings have made a payment successfully.
  isSuccess: boolean;

  constructor(
    eventId: string,
    eventOccurrenceDate: string | undefined,
    eventTitle: string,
    processedBookings: ProcessedBooking[],
    eventPrice: number,
    processedBookingsCount: number,
    totalPrice: number,
    isSuccess: boolean
  ) {
    this.eventId = eventId;
    this.eventOccurrenceDate = eventOccurrenceDate
      ? new Date(eventOccurrenceDate)
      : undefined;
    this.eventTitle = eventTitle;
    this.processedBookings = processedBookings;
    this.eventPrice = eventPrice;
    this.processedBookingsCount = processedBookingsCount;
    this.totalPrice = totalPrice;
    this.isSuccess = isSuccess;
  }

  get id(): string {
    return `${this.eventId}+${this.eventOccurrenceDate}`;
  }
}
